import React, { Component } from "react";

import { Metric, selectFormat } from "./../Utils/Utils.js";
import Heading from "../Elements/Heading";

class SubscriberRenwalCancel extends Component {
  render() {
    const { data } = this.props;

    const bar2_width = (data.rebilled * 100) / data.ending_periods;
    const bar1_style = { width: "100%" };
    const bar2_style = { width: bar2_width + "%" };

    return (
      <div className="row">
        <div className="col-12">
          <div className="text-center">
            <Heading size={6} className={"mb-0 text-gray"}>
              {data.name}
            </Heading>
          </div>

          <div className="bar-chart">
            <div className="bar-chart__container pl-3 pr-3">
              <div
                className="bar-chart__bar bar-chart__bar--pink"
                style={bar1_style}
              ></div>
              <div className="bar-chart__data">
                <div className="bar-chart__label">
                  Pay Subscribers with Pay Period Ending
                </div>
                <div className="bar-chart__value">
                  {selectFormat("number", data.ending_periods)}
                </div>
              </div>
            </div>

            <div className="bar-chart__container pl-3 pr-3">
              <div
                className="bar-chart__bar bar-chart__bar--green"
                style={bar2_style}
              ></div>
              <div className="bar-chart__data">
                <div className="bar-chart__label">Rebilled Successfully</div>
                <div className="bar-chart__value">
                  {selectFormat("number", data.rebilled)}
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-3">
              <Heading size={6} className={"mb-0"}>
                Conversion Rate
              </Heading>
              <Metric
                {...data.conversion_rate}
                size={"sm"}
                format={"%"}
                type="percentage"
              />
            </div>

            <div className="col-3">
              <Heading size={6} className={"mb-0"}>
                Cancelled
              </Heading>
              <Metric {...data.cancelled} size={"sm"} format={"0"} />
            </div>

            <div className="col-3">
              <Heading size={6} className={"mb-0"}>
                Churn Rate
              </Heading>
              <Metric {...data.churn_rate} size={"sm"} type="percentage" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SubscriberRenwalCancel;
